module.exports = __webpack_public_path__ + "fonts/CosmopolitanScript-Regular.c1093142.woff";